export default {
  strict: true,
  namespaced: true,
  state: {
    unseen: 0
  },
  getters: {
    unseen: (state, getters) => {
      return state.unseen
    }
  },
  mutations: {
    increment: state => {
      state.unseen++
    },
    decrement: state => {
      if (state > 0) {
        state.unseen--
      }
    },
    update: (state, payload) => {
      state.unseen = payload
    }
  }
}